import { useCallback, useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import { AI_LOAD_API, CHEMICAL_DB_API_HOST, JSON_HEADERS } from './constants';
import type { AiLoadResponse, FetchAiLoadAdvisory } from './types';

const useAiLoadAdvisory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedPost } = useFetch({
        apiHost: CHEMICAL_DB_API_HOST,
        headers: JSON_HEADERS
    });
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetch: FetchAiLoadAdvisory = useCallback(
        async ({ request }) => {
            try {
                setIsLoading(true);

                return await withRetry(
                    () => authenticatedPost<AiLoadResponse>(AI_LOAD_API, JSON.stringify(request)),
                    CONNECTION_ERROR,
                    () => fetch({ request })
                );
            } finally {
                setIsLoading(false);
            }
        },
        [authenticatedPost, withRetry, CONNECTION_ERROR]
    );

    return { fetch, isLoading };
};

export default useAiLoadAdvisory;
